import { Component, Input, OnInit } from '@angular/core';
import { NzDrawerService } from 'ng-zorro-antd/drawer';
import { Cell } from '../../cell';
import { LayoutService } from '../../layout.service';

@Component({
  selector: 'app-cell-date',
  templateUrl: './cell-date.component.html',
  styleUrls: ['./cell-date.component.less'],
})
export class CellDateComponent extends Cell {
  constructor(
    public layoutService: LayoutService,
    public drawerService: NzDrawerService
  ) {
    super(layoutService, drawerService);
  }
}
